import { APP_STORE_URL } from "../../config/app";
import { APP_STORE_BADGE, LINKS } from "../../data/site";
import { CTA, Reveal } from "./primitives";

const APP_ICON = "/media/app/yoga-sutras-icon-256.jpg";
import SutraExplorer from "./SutraExplorer";

const TRIAD = [
  { word: "Learn", text: "Understand what the sutra is saying, in its original language and in clear, accessible language." },
  { word: "Meditate", text: "Move from understanding the teaching to experiencing what it points toward." },
  { word: "Embody", text: "Recognize it in your thoughts, relationships, choices and everyday experience." },
];

export default function YogaSutras() {
  return (
    <section id="sutras" aria-labelledby="sutras-title" data-testid="sutras-section" className="relative scroll-mt-24 bg-ivory-50 px-3 py-16 sm:px-6 lg:px-10 lg:py-24">
      <div className="relative mx-auto grid max-w-7xl gap-14 overflow-hidden rounded-[2rem] bg-sand-light px-5 py-14 shadow-[0_30px_60px_-40px_rgba(43,38,32,0.35)] ring-1 ring-ink/[0.06] sm:px-10 lg:grid-cols-12 lg:gap-10 lg:px-14 lg:py-20" data-testid="sutras-card">
        <div aria-hidden className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_60%_50%_at_10%_0%,rgba(242,160,127,0.18),transparent_70%)]" />
        <div className="relative lg:col-span-4 lg:pt-6">
          <Reveal>
            <div className="flex items-center gap-4" data-testid="sutras-app-identity">
              <img src={APP_ICON} alt="Yoga Sutras: Presence Revealed app icon" width="256" height="256" loading="lazy" className="h-[76px] w-[76px] rounded-[22%] shadow-[0_14px_30px_-14px_rgba(43,38,32,0.55)] ring-1 ring-ink/10" data-testid="sutras-app-icon" />
              <div>
                <span className="inline-flex items-center rounded-full bg-ink px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.2em] text-ivory" data-testid="sutras-iphone-label">iPhone app</span>
                <p className="mt-2 text-sm font-semibold tracking-wide text-coral-ink" data-testid="sutras-available-now">Available Now on the App Store</p>
              </div>
            </div>
            <h2 id="sutras-title" className="mt-7 font-display text-[2.4rem] font-light leading-[1.05] text-ink sm:text-5xl lg:text-[3.4rem]">
              Yoga Sutras: <em className="italic">Presence Revealed</em>
            </h2>
            <p className="mt-5 font-display text-2xl italic text-coral-ink">Learn. Meditate. Embody.</p>
            <p className="mt-4 text-[15px] font-medium text-ink" data-testid="sutras-welcome-line">For anyone curious about the mind — no yoga experience needed.</p>
            <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" aria-label="Download on the App Store" data-testid="sutras-appstore-badge" className="mt-6 inline-flex rounded-[12px] transition-transform duration-300 hover:-translate-y-0.5">
              <img src={APP_STORE_BADGE} alt="" width="2161" height="728" loading="lazy" className="h-[48px] w-auto" />
            </a>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-7 text-base leading-relaxed text-ink-soft sm:text-lg">
              You don't need to know the Yoga Sutras to begin. You only need to be curious about your own experience.
            </p>
          </Reveal>
          <Reveal delay={0.15} as="ul" className="mt-8 border-t border-ink/10">
            {TRIAD.map((t) => (
              <li key={t.word} className="flex gap-4 border-b border-ink/10 py-3.5">
                <span className="w-[5.5rem] shrink-0 font-display text-xl italic text-coral-ink">{t.word}</span>
                <span className="text-sm leading-relaxed text-ink-soft">{t.text}</span>
              </li>
            ))}
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 font-display text-2xl italic leading-snug text-ink">Not simply something to learn. Something to live.</p>
            <p className="mt-2 text-sm font-medium tracking-wide text-ink-soft">One sutra at a time.</p>
          </Reveal>
          <Reveal delay={0.25} className="mt-10 hidden lg:block">
            <CTA href={LINKS.sutras} testid="sutra-explore-app-button">
              Explore the Yoga Sutras App
            </CTA>
          </Reveal>
        </div>

        <SutraExplorer
          className="relative lg:col-span-8"
          footer={
            <div className="mt-10 lg:hidden">
              <CTA href={LINKS.sutras} testid="sutra-explore-app-button-mobile" className="w-full sm:w-auto">
                Explore the Yoga Sutras App
              </CTA>
            </div>
          }
        />
      </div>
    </section>
  );
}
